<template>
  <div class="dataSource">
    <div class="title">我要勘误</div>
    <div class="tip">
      <i class="icon_tip">i</i>
      <div>
        请详细描述您需要勘误的内容和问题，您的勘误申请将提交至数据来源方{{
          form.data.dataSourceName
        }}，联系方式：{{ form.data.businessPhone }}，对方核实无误后将完成勘误。
      </div>
    </div>
    <ul class="currentData">
      <li>字段名称：{{ form.data.dataName }}</li>
      <!-- <li>数据内容：{{ form.data.dataValue }}</li> -->
      <li v-if="form.data.dataName === '时间'">
        数据内容：{{
          form.data.dataValue.split(",").length > 1
            ? form.data.dataValue.split(",")[0] +
              "-" +
              form.data.dataValue.split(",")[1]
            : form.data.dataValue.split(",")[0]
        }}
      </li>
      <li v-else>数据内容：{{ form.data.dataValue }}</li>
      <li>数据来源：{{ form.data.dataSourceName }}</li>
      <li>
        采集时间：{{
          form.data.collectionDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
        }}
      </li>
      <li>
        收录时间：{{
          form.data.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
        }}
      </li>
    </ul>
    <div class="subTitle">勘误内容：</div>
    <el-input
      v-model="form.applyRemark"
      type="textarea"
      :autosize="{ minRows: 7, maxRows: 7 }"
    ></el-input>
    <!-- <el-timeline>
      <el-timeline-item v-for="(item, index) in records" :key="index">
        <ul>
          <li>更新内容：{{ item["更新内容"] }}</li>
          <li>数据来源：{{ item["数据来源"] }}</li>
          <li>采集时间：{{ item["采集时间"] }}</li>
          <li>收录时间：{{ item["收录时间"] }}</li>
        </ul>
      </el-timeline-item>
    </el-timeline> -->
    <button class="btn_edit" @click="handleCorrigendum">提交勘误</button>
  </div>
</template>

<script>
import { corrigendaRecordApply } from "@/api/corrigenda";
import { dataRecord } from "@/api/user";
import Back from "../../components/Back.vue";
export default {
  components: { Back },
  created() {
    this.id = this.$route.query.id;
    this.getList();
  },
  data() {
    return {
      id: undefined,
      form: {
        applyRemark: "",
        data: JSON.parse(localStorage.getItem("corrigendumInfo"))
      }
    };
  },
  methods: {
    getList() {
      dataRecord(this.id).then(res => {
        console.log(res);
        this.form.data = res.data.d[0];
      });
    },
    handleCorrigendum() {
      corrigendaRecordApply(this.form).then(res => {
        if (res.data.c === 200) {
          this.$message.success('提交成功')
          this.$router.push("corrigendumRecord");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dataSource {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  ul {
    list-style: none;
  }
  .title {
    display: flex;
    justify-content: space-between;
    color: #393939;
    font-size: 20px;
    font-weight: bold;
    span {
      color: #8d8d8d;
      cursor: pointer;
    }
  }
  .tip {
    margin-top: 33px;
    font-size: 14px;
    color: #6e6e6e;
    display: flex;
    div {
      line-height: 26px;
    }
    .icon_tip {
      background: #ff8d65;
      width: 23px;
      height: 20px;
      display: inline-block;
      color: #fff;
      font-style: normal;
      margin-top: 3px;
      text-align: center;
      border-radius: 20px;
      margin-right: 12px;
      margin-left: 2px;
    }
  }
  .subTitle {
    margin-bottom: 15px;
    font-weight: bold;
  }
  .btn_edit {
    width: 106px;
    height: 41px;
    background: #3a61b1;
    border-radius: 21px;
    border: 0;
    color: #fff;
    margin-top: 23px;
  }
  .currentData {
    padding: 31px 0px 34px 32px;
    background: #f0f2f5;
    list-style: none;
    margin-top: 28px;
    margin-bottom: 23px;
    font-size: 14px;
    color: #6e6e6e;
    li {
      margin-bottom: 23px;
      &:last-child {
        margin-bottom: 0;
      }
    }

    // .el-timeline-item__content {
    // }
  }
  .el-timeline {
    .el-timeline-item__tail {
      position: absolute;
      left: 5px;
      top: 15px;
      height: 100%;
      border-left: 1px solid #3a61b1;
    }
    .el-timeline-item__content {
      color: #6e6e6e;
    }
    .el-timeline-item__wrapper {
      position: relative;
      padding-left: 22px;
      top: 7px;
    }
    .el-timeline-item__node {
      background-color: #3a61b1;
    }
    .el-timeline-item__node--normal {
      left: 2px;
      width: 7px;
      height: 7px;
      top: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/Corrigendum.vue